import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
} from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

export interface CommunicatingEntity {
  name: React.ReactChild
  mailingAddress: React.ReactChild
  webAddress: React.ReactChild
}

export interface CommunicatingEntitiesProps {
  entities: ReadonlyArray<CommunicatingEntity>
}

const StyledPaper = styled(Paper)`
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
  color: inherit;
`

const StyledTable = styled(Table)`
  margin-top: 16px;
`

const StyledTableHead = styled(TableHead)``

const StyledTableCell = styled(TableCell)`
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool400};
  color: inherit;
  font-size: inherit;

  ${StyledTableHead} & {
    white-space: nowrap;
  }
`

const StyledDescriptionList = styled.dl`
  margin: 0;
`

const StyledDescription = styled.dd`
  margin-left: 16px;
`

const StyledTerm = styled.dt`
  font-weight: 500;
  ${StyledDescription} ~ & {
    margin-top: 16px;
  }
`

export const CommunicatingEntities: React.VFC<CommunicatingEntitiesProps> = ({ entities }) => {
  const theme = useTheme()
  const isLargeViewPort = useMediaQuery(theme.breakpoints.up('md'))

  if (isLargeViewPort) {
    return (
      <StyledTable size="small">
        <StyledTableHead>
          <TableRow>
            <StyledTableCell>Organization’s Name</StyledTableCell>
            <StyledTableCell>Mailing Address</StyledTableCell>
            <StyledTableCell>Web Address</StyledTableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {entities.map(({ name, mailingAddress, webAddress }, index) => (
            <TableRow key={typeof name === 'string' ? name : index}>
              <StyledTableCell>{name}</StyledTableCell>
              <StyledTableCell>{mailingAddress}</StyledTableCell>
              <StyledTableCell>{webAddress}</StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    )
  }

  return (
    <>
      {entities.map(({ name, mailingAddress, webAddress }, index) => (
        <Box mt={8} key={typeof name === 'string' ? name : index}>
          <StyledPaper variant="outlined">
            <Box p={8}>
              <StyledDescriptionList>
                <StyledTerm>Organization’s Name</StyledTerm>
                <StyledDescription>{name}</StyledDescription>
                <StyledTerm>Mailing Address</StyledTerm>
                <StyledDescription>{mailingAddress}</StyledDescription>
                <StyledTerm>Web Address</StyledTerm>
                <StyledDescription>{webAddress}</StyledDescription>
              </StyledDescriptionList>
            </Box>
          </StyledPaper>
        </Box>
      ))}
    </>
  )
}
